/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiScenarioVersionParameter } from './InternalApiScenarioVersionParameter';
import {
    InternalApiScenarioVersionParameterFromJSON,
    InternalApiScenarioVersionParameterFromJSONTyped,
    InternalApiScenarioVersionParameterToJSON,
    InternalApiScenarioVersionParameterToJSONTyped,
} from './InternalApiScenarioVersionParameter';
import type { InternalApiUserBasicDetails } from './InternalApiUserBasicDetails';
import {
    InternalApiUserBasicDetailsFromJSON,
    InternalApiUserBasicDetailsFromJSONTyped,
    InternalApiUserBasicDetailsToJSON,
    InternalApiUserBasicDetailsToJSONTyped,
} from './InternalApiUserBasicDetails';
import type { InternalApiScenarioVersionStatus } from './InternalApiScenarioVersionStatus';
import {
    InternalApiScenarioVersionStatusFromJSON,
    InternalApiScenarioVersionStatusFromJSONTyped,
    InternalApiScenarioVersionStatusToJSON,
    InternalApiScenarioVersionStatusToJSONTyped,
} from './InternalApiScenarioVersionStatus';

/**
 * 
 * @export
 * @interface InternalApiScenarioVersionBasic
 */
export interface InternalApiScenarioVersionBasic {
    /**
     * 
     * @type {string}
     * @memberof InternalApiScenarioVersionBasic
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof InternalApiScenarioVersionBasic
     */
    versionId: number;
    /**
     * 
     * @type {InternalApiScenarioVersionStatus}
     * @memberof InternalApiScenarioVersionBasic
     */
    status: InternalApiScenarioVersionStatus;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScenarioVersionBasic
     */
    note?: string;
    /**
     * 
     * @type {InternalApiUserBasicDetails}
     * @memberof InternalApiScenarioVersionBasic
     */
    updatedBy: InternalApiUserBasicDetails;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiScenarioVersionBasic
     */
    updatedTime: Date;
    /**
     * 
     * @type {Array<InternalApiScenarioVersionParameter>}
     * @memberof InternalApiScenarioVersionBasic
     */
    parameters?: Array<InternalApiScenarioVersionParameter>;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScenarioVersionBasic
     */
    logic?: string;
}



/**
 * Check if a given object implements the InternalApiScenarioVersionBasic interface.
 */
export function instanceOfInternalApiScenarioVersionBasic(value: object): value is InternalApiScenarioVersionBasic {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('versionId' in value) || value['versionId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('updatedBy' in value) || value['updatedBy'] === undefined) return false;
    if (!('updatedTime' in value) || value['updatedTime'] === undefined) return false;
    return true;
}

export function InternalApiScenarioVersionBasicFromJSON(json: any): InternalApiScenarioVersionBasic {
    return InternalApiScenarioVersionBasicFromJSONTyped(json, false);
}

export function InternalApiScenarioVersionBasicFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScenarioVersionBasic {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'versionId': json['versionId'],
        'status': InternalApiScenarioVersionStatusFromJSON(json['status']),
        'note': json['note'] == null ? undefined : json['note'],
        'updatedBy': InternalApiUserBasicDetailsFromJSON(json['updatedBy']),
        'updatedTime': (new Date(json['updatedTime'])),
        'parameters': json['parameters'] == null ? undefined : ((json['parameters'] as Array<any>).map(InternalApiScenarioVersionParameterFromJSON)),
        'logic': json['logic'] == null ? undefined : json['logic'],
    };
}

export function InternalApiScenarioVersionBasicToJSON(json: any): InternalApiScenarioVersionBasic {
    return InternalApiScenarioVersionBasicToJSONTyped(json, false);
}

export function InternalApiScenarioVersionBasicToJSONTyped(value?: InternalApiScenarioVersionBasic | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'versionId': value['versionId'],
        'status': InternalApiScenarioVersionStatusToJSON(value['status']),
        'note': value['note'],
        'updatedBy': InternalApiUserBasicDetailsToJSON(value['updatedBy']),
        'updatedTime': value['updatedTime'].toISOString(),
        'parameters': value['parameters'] == null ? undefined : ((value['parameters'] as Array<any>).map(InternalApiScenarioVersionParameterToJSON)),
        'logic': value['logic'],
    };
}

